export class UpdateStatusQueueRequest{
    public idStatusQueue: number;
}